/**
 * Presentation helpers for the global-search results — icon, color and
 * label per result type, plus the substring highlighter used inline.
 *
 * Pure functions / tiny components only — no hooks, no fetch.
 */

import React from "react";
import { Plane, Users, User, Wrench, DollarSign, Search } from "lucide-react";

export function getTypeIcon(type) {
  switch (type) {
    case "flight":
      return <Plane className="w-4 h-4" />;
    case "aircraft":
      return <Plane className="w-4 h-4" />;
    case "staff":
      return <User className="w-4 h-4" />;
    case "passenger":
      return <Users className="w-4 h-4" />;
    case "maintenance":
      return <Wrench className="w-4 h-4" />;
    case "expense":
      return <DollarSign className="w-4 h-4" />;
    default:
      return <Search className="w-4 h-4" />;
  }
}

export function getTypeColor(type) {
  switch (type) {
    case "flight":
      return "text-blue-400 bg-blue-500/10";
    case "aircraft":
      return "text-cyan-400 bg-cyan-500/10";
    case "staff":
      return "text-green-400 bg-green-500/10";
    case "passenger":
      return "text-purple-400 bg-purple-500/10";
    case "maintenance":
      return "text-orange-400 bg-orange-500/10";
    case "expense":
      return "text-yellow-400 bg-yellow-500/10";
    default:
      return "text-slate-400 bg-slate-500/10";
  }
}

/** Highlight the matched substring inside a result value. */
export function highlightMatch(value, query) {
  if (!value || !query) return value;
  const strValue = String(value);
  const idx = strValue.toLowerCase().indexOf(query.toLowerCase());
  if (idx === -1) return strValue;
  return (
    <>
      {strValue.slice(0, idx)}
      <span className="text-white font-semibold">{strValue.slice(idx, idx + query.length)}</span>
      {strValue.slice(idx + query.length)}
    </>
  );
}

export const TYPE_ORDER = ["maintenance", "staff", "aircraft", "flight", "passenger", "expense"];

/** Router target per result type (back-compat with the original switch). */
export function searchResultRoute(type) {
  switch (type) {
    case "flight":
    case "passenger":
      return "/flights";
    case "aircraft":
      return "/fleet";
    case "staff":
      return "/staff";
    case "maintenance":
      return "/maintenance";
    case "expense":
      return "/expenses";
    default:
      return null;
  }
}
